// Plural Actions
export const GET_V2_MAINTENANCE_ITEMS = "GET_V2_MAINTENANCE_ITEMS";
export const getV2MaintenanceItems = (category_id) => {
  const request = axios.get(`/v2/maintenance/items.json?category_id=${category_id}`);
  return {
    type: GET_V2_MAINTENANCE_ITEMS,
    payload: request,
  };
};
